import { twMerge } from "tailwind-merge";
import { Input } from "./Input";

export interface NumberRangeValue {
  min?: number;
  max?: number;
}

interface NumberRangeInputProps {
  value: NumberRangeValue;
  onChange: (value: NumberRangeValue) => void;
  min?: number;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  className?: string;
}

function parseAmount(rawValue: string, floor?: number): number | undefined {
  if (rawValue === "") return undefined;
  const parsed = Number(rawValue);
  return floor !== undefined && parsed < floor ? floor : parsed;
}

const NO_SPINNER_CLASSNAME =
  "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none";

export function NumberRangeInput({
  value,
  onChange,
  min: floor,
  minPlaceholder = "Min",
  maxPlaceholder = "Max",
  className,
}: NumberRangeInputProps) {
  const { min, max } = value;

  const handleMinChange = (rawValue: string) => {
    onChange({ min: parseAmount(rawValue, floor), max });
  };

  const handleMaxChange = (rawValue: string) => {
    onChange({ min, max: parseAmount(rawValue, floor) });
  };

  const handleMinBlur = () => {
    if (min !== undefined && max !== undefined && min > max) {
      onChange({ min, max: min });
    }
  };

  const handleMaxBlur = () => {
    if (min !== undefined && max !== undefined && max < min) {
      onChange({ min: max, max });
    }
  };

  return (
    <div className={twMerge("flex flex-col gap-2", className)}>
      <Input
        type="number"
        size="sm"
        autoFocus
        min={floor}
        className={NO_SPINNER_CLASSNAME}
        value={min ?? ""}
        placeholder={minPlaceholder}
        onChange={(e) => handleMinChange(e.target.value)}
        onBlur={handleMinBlur}
      />
      <Input
        type="number"
        size="sm"
        min={floor}
        className={NO_SPINNER_CLASSNAME}
        value={max ?? ""}
        placeholder={maxPlaceholder}
        onChange={(e) => handleMaxChange(e.target.value)}
        onBlur={handleMaxBlur}
      />
    </div>
  );
}
